import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule, MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { GeneratedDocumentsTypeSlugsForDiary } from '../../../../dave-data-module/entities/generatedDocumentsType.entity';
import { GeneratedDocumentsType } from '../../../../dave-data-module/graphql-types';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../../helper/helper';
import { DiaryDataService } from '../../../../services/diary-data.service';
import { LoadingService } from '../../../../services/loading.service';
import { defaultResizePixel, getExportOptions, imageQualityEnum, imageQualityOptions } from '../diary-export.helper';

export type ExportEventDialogComponentDialogReturnData = undefined | GeneratedDocumentsType[];
export interface ExportEventDialogComponentDialogData {
    GeneratedDocumentsType: GeneratedDocumentsTypeSlugsForDiary;
    EventIds: number[];
}

@Component({
    selector: 'app-export-event-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, MatLegacyFormFieldModule, MatLegacyInputModule, MatLegacyRadioModule, MatLegacySlideToggleModule, ReactiveFormsModule, MatLegacyDialogModule, AppButtonModule],
    templateUrl: './export-event-dialog.component.html',
    styleUrls: ['./export-event-dialog.component.scss'],
})
export class ExportEventDialogComponent {
    static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
    };
    public GeneratedDocumentsType: GeneratedDocumentsTypeSlugsForDiary;
    public EventIds: number[];
    protected FormGroup = new FormGroup({
        exportWorkTimes: new FormControl<boolean | null>(true),
        showFooter: new FormControl<boolean | null>(false),
        imageColCount: new FormControl<1 | 2 | 3>(1),
        imageMinRowCount: new FormControl<1 | 2 | 3>(1),
        imageQuality: new FormControl<imageQualityEnum>(imageQualityEnum.default),
        imageQualityPX: new FormControl<number | null>(null),
    });
    public readonly defaultResizePixel = defaultResizePixel;
    protected readonly imageQualityOptions = imageQualityOptions;
    protected title: string;
    constructor(
        @Inject(MAT_DIALOG_DATA) data: ExportEventDialogComponentDialogData,
        protected ls: LoadingService,
        private diaryService: DiaryDataService,
        private dialogRef: MatLegacyDialogRef<ExportEventDialogComponent, ExportEventDialogComponentDialogReturnData>,
    ) {
        if (data) {
            this.GeneratedDocumentsType = data.GeneratedDocumentsType;
            this.EventIds = data.EventIds;
        }
        this.title = this.EventIds?.length === 1 ? 'Störung exportieren' : 'Störungen exportieren';
    }
    submit() {
        console.log(this.EventIds)
        const lsKey = 'generate-event-export--' + this.EventIds.join(',');
        this.ls.startLoading(lsKey);
        const options = getExportOptions(this.FormGroup.value);
        this.diaryService
            .generateEvents(this.GeneratedDocumentsType, this.EventIds, options)
            .then((res) => {
                if (res?.length) {
                    this.dialogRef.close(res);
                }
            })
            .finally(() => this.ls.endLoading(lsKey));
    }

    protected readonly imageQualityEnum = imageQualityEnum;
}
